export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 3.13,
        "transcript": "Atam itertuten tua-ll' aqumluten. Kitak-wa",
        "translation": "You came in then sat down. Let's begin."
    },
    "2": {
        "startTime": 3.76,
        "endTime": 4.88,
        "transcript": "Ready?",
        "translation": "Ready?"
    },
    "3": {
        "startTime": 8.91,
        "endTime": 10.61,
        "transcript": "Tau͡ga-q' ayaglirlii?",
        "translation": "Shall I begin?"
    },
    "4": {
        "startTime": 10.615,
        "endTime": 15.485,
        "transcript": "Una yuungcautnguuq akaurtellrani yuungcauteput rosewort.",
        "translation": "This is medicinal, our medicine from a long time ago rosewort."
    },
    "5": {
        "startTime": 15.795,
        "endTime": 20.455,
        "transcript": "Yugtun-llu... caulria im'?",
        "translation": "And in Yup'ik... what is it again?"
    },
    "6": {
        "startTime": 20.64,
        "endTime": 23.26,
        "transcript": "Nalluyagutaqa-am tayima.",
        "translation": "I've forgotten it."
    },
    "7": {
        "startTime": 30.705,
        "endTime": 36.885,
        "transcript": "Maa-i makut yuungcautelput akaurtellrani. Wanigg' uigtuaqataraqa kepluku.",
        "translation": "This was our medicine a long time ago. I'm going to cut and taste it."
    },
    "8": {
        "startTime": 37.24,
        "endTime": 42.28,
        "transcript": "Makuksagaat-am nerellrit assiitqapigtut.",
        "translation": "It's terrible eating this little things."
    },
    "9": {
        "startTime": 42.285,
        "endTime": 49.305,
        "transcript": "Tua-i-llu wii igyariqellemni tamalkuan nerelqeka, iluka-ll' assiriluni qama-i.",
        "translation": "Then when I had a sore throat, I eat the entire then, then my stomach felt better inside."
    },
    "10": {
        "startTime": 50.56,
        "endTime": 53.45,
        "transcript": "Ilukaalriani-llu assirtut.",
        "translation": "They're good for stomach pains too."
    },
    "11": {
        "startTime": 58.974,
        "endTime": 62.714,
        "transcript": "Yuungcautelput makut akaurtellrani maa-i.",
        "translation": "This was our medicine a long time ago."
    },
    "12": {
        "startTime": 62.719,
        "endTime": 65.809,
        "transcript": "Caqlat-gguq maa-i Yugtun, caqlat.",
        "translation": "These are called caqlat in Yup'ik, caqlat."
    },
    "13": {
        "startTime": 66.189,
        "endTime": 71.159,
        "transcript": "Makut, makut neryuitait, makut tau͡gaam acilquit.",
        "translation": "They don't eat these, except for their roots."
    },
    "14": {
        "startTime": 73.189,
        "endTime": 80.879,
        "transcript": "Nallullruyaaqaput. Aanama qanruquratullruanga im'um Ceng'ulriim, my great-grandma, tamakuneng.",
        "translation": "We didn't know about them. My mom always used to tell me, Ceng'ulria, my great-grandma, about those."
    },
    "15": {
        "startTime": 80.879,
        "endTime": 85.174,
        "transcript": "Qaillun-llu maa-i-ll' ayuquciit cimirluteng.",
        "translation": "And they've somehow changed these days."
    },
    "16": {
        "startTime": 85.174,
        "endTime": 90.164,
        "transcript": "Kass'atun pingluteng, akaurtellrani pilteng aturpegnaki.",
        "translation": "They've started living Western lives, not using what they did long ago."
    },
    "17": {
        "startTime": 90.164,
        "endTime": 92.694,
        "transcript": "Maa-i cimirluteng.",
        "translation": "They've changed now."
    },
    "18": {
        "startTime": 94.214,
        "endTime": 99.604,
        "transcript": "Alingcetaarturluta-ll' maa-i pitullruluta akaurtellrani.",
        "translation": "They also used to try to scare us a long time ago."
    },
    "19": {
        "startTime": 99.884,
        "endTime": 107.684,
        "transcript": "Angutmun-llu nuliqsuguarluta caciqniluta. Tamakuneng tamaa-i aanama qanrut'tulqaanga.",
        "translation": "They said that something would happen when we pretened to be a man's wife. That's what my mother used to tell me."
    },
    "20": {
        "startTime": 108.209,
        "endTime": 116.704,
        "transcript": "Cunagg' maa-i ak'allaurcama enqaknauqa imna aanama qanellra.",
        "translation": "It turned out as I've turned old now, I would remember what my mother said."
    },
    "21": {
        "startTime": 116.704,
        "endTime": 123.814,
        "transcript": "Aanaka tua-i qantulliuq terr'a tekilluku, tekitaqamku tau͡g' enqaknauqa grandma-qa.",
        "translation": "My mother would say, when I reached the bottom, when I reach the bottom I would remember my grandma."
    },
    "22": {
        "startTime": 123.814,
        "endTime": 127.564,
        "transcript": "Wii grandma-qa aanakpiksukluku pilqaqa.",
        "translation": "I thought my grandma was my real mom."
    },
    "23": {
        "startTime": 127.919,
        "endTime": 139.252,
        "transcript": "Aquiqcaarraarlua-ll' qagaani aquirraarlua itraqama qec'irluku emuugkeneng emutulua. Qayutun, 13-aq-ll' cipesngaluku.",
        "translation": "And after I played, when I came in after I played outside, I would embrace her and suckle on her breasts. How old, I was older than 13."
    },
    "24": {
        "startTime": 139.656,
        "endTime": 146.856,
        "transcript": "Tua-i tamaani wii piipiqellruamegteńga ingkut aanama.",
        "translation": "It was because I was their baby, my mother's [baby]."
    },
    "25": {
        "startTime": 146.875,
        "endTime": 150.731,
        "transcript": "Piipiqlua tau͡g keyima arnaulua tau͡g keyirma.",
        "translation": "I was the baby, the only girl."
    },
    "26": {
        "startTime": 150.734,
        "endTime": 156.945,
        "transcript": "Ilarugapuk tayim', pingayurrauluta wanigg' anertequkut.",
        "translation": "Our big family, only three of us are now living."
    },
    "27": {
        "startTime": 157.114,
        "endTime": 160.759,
        "transcript": "Ukuk malruk angutngulutek, wii-gg' atauciq.",
        "translation": "These two are men, and I'm alone."
    },
    "28": {
        "startTime": 160.768,
        "endTime": 165.513,
        "transcript": "Tau͡g keyirma tau͡g ataucirraulua anerteqlua.",
        "translation": "I am the only one who's alive."
    },
    "29": {
        "startTime": 165.526,
        "endTime": 170.538,
        "transcript": "Tamakut TB-m tuqutellruluki al'qanka.",
        "translation": "TB claimed my older sisters."
    },
    "30": {
        "startTime": 170.551,
        "endTime": 181.029,
        "transcript": "Wii tau͡ga aanama tau͡gaam piksuamia caqcaarlua tau͡ga anerteqevkallrullinianga, caqcaqapigglua.",
        "translation": "Since my mother wanted me, she did whatever she could to make me live, whatever she could."
    },
    "31": {
        "startTime": 181.039,
        "endTime": 190.173,
        "transcript": "Makuneng-ll' nerevkatulua miktellemni. Neqnialliq'nge'rma ner'tullruluki igluki-llu.",
        "translation": "She also had me eat these when I was small. Though I thought they tasted made, I would eat and swallow them."
    },
    "32": {
        "startTime": 191.211,
        "endTime": 194.01,
        "transcript": "Akaurtellrani tua-i tamakut.",
        "translation": "Those are things from long ago."
    },
    "33": {
        "startTime": 194.019,
        "endTime": 199.396,
        "transcript": "Tuamtell' caqerlua-am qanrutaanga aanama",
        "translation": "Then one day, my mother told me"
    },
    "34": {
        "startTime": 199.849,
        "endTime": 202.649,
        "transcript": "Camineng? \"Tutgarrluu.\" \"Ai?\"",
        "translation": "What did she call me? \"Grandchild.\" \"What?\""
    },
    "35": {
        "startTime": 205.095,
        "endTime": 211.699,
        "transcript": "Pakissaagkuma-gguq, pakissaakuma-gguq utngungssaraat neqaitneng pakissaakuma",
        "translation": "She said that if I go search for vole caches, she said that if I search gor mare's-tail plant tubers in vole caches"
    },
    "36": {
        "startTime": 211.704,
        "endTime": 218.982,
        "transcript": "Pakikengkuma, pakikengkuma quarruugneng, needlefish",
        "translation": "She said that if I uncover quarruuget [sticklebacks], needlefish, in a vole cache"
    },
    "37": {
        "startTime": 219.605,
        "endTime": 224.916,
        "transcript": "Taukut-gguq ilaiqaqilaki ataucimeng tau͡gaam, just one.",
        "translation": "She said I should take only one, just one."
    },
    "38": {
        "startTime": 224.923,
        "endTime": 230.5,
        "transcript": "Tuai-ll' pakissaag[?] pakikengua ik'ikik' pekluteng.",
        "translation": "Then as I searched for vole cahces, I came upon one, so many were moving."
    },
    "39": {
        "startTime": 230.585,
        "endTime": 238.14,
        "transcript": "Tua-ll' umyugartuqaqilii, \"Ala, aanama-ggem pakikengkuma quarruugneng ataucirmeng neresqelqaanga.\"",
        "translation": "Then I thought, \"Oh my, didn't my mother tell me that if I find sticklebacks that I should eat one?\""
    },
    "40": {
        "startTime": 238.152,
        "endTime": 241.219,
        "transcript": "Tau͡ga nerqaqilii ataucirmeng.",
        "translation": "Then I ate one."
    },
    "41": {
        "startTime": 241.227,
        "endTime": 247.161,
        "transcript": "Ayakataquma tau͡ga cailkamun-llu alarqurnauraanga tau͡gaten.",
        "translation": "When I was going to go to the wilderness, she would instruct me like that."
    },
    "42": {
        "startTime": 247.167,
        "endTime": 253.134,
        "transcript": "Tuamtell' caqerlunung, caqerlua aipaqa tauna pakikenguq",
        "translation": "Then one day, my companion found a filled vole cache"
    },
    "43": {
        "startTime": 253.147,
        "endTime": 257.325,
        "transcript": "Ignatius Black-aq-llu friend-aqellruamegnuk miktellmegni.",
        "translation": "Because Ignatius Black and I were friends when we were small."
    },
    "44": {
        "startTime": 257.334,
        "endTime": 261.389,
        "transcript": "Pakikengami-am qayagpagaanga, \"Ala, cat makut?\"",
        "translation": "When he found a filled vole cache, he called to me, \"Oh my, what are these?\""
    },
    "45": {
        "startTime": 261.403,
        "endTime": 267.747,
        "transcript": "Ala maaten ullagluku piaqa imkut ciissit.",
        "translation": "Oh my, I went to him and found those bugs."
    },
    "46": {
        "startTime": 271.766,
        "endTime": 275.722,
        "transcript": "Cat imkut ciutmun itetulit meriit.",
        "translation": "Those things that go into ears, meriit."
    },
    "47": {
        "startTime": 275.897,
        "endTime": 280.686,
        "transcript": "Ala-i tamakut pekluteng. Qaill'-kiq nernaqsartat?",
        "translation": "Oh my, they were moving. I wonder how they could be eaten?"
    },
    "48": {
        "startTime": 280.699,
        "endTime": 287.61,
        "transcript": "[?]anguaryaaqvimineng tau͡ga niiskilaku tauna aipaqa, \"Quarruugunritut. Wii nerngaitua tamakuneng.\"",
        "translation": "After he had [?], I heard my companion say, \"They're not sticklebacks. I won't eat those.\""
    },
    "49": {
        "startTime": 287.616,
        "endTime": 290.105,
        "transcript": "Ayaglunung-llu.",
        "translation": "And we traveled on."
    },
    "50": {
        "startTime": 290.502,
        "endTime": 299.079,
        "transcript": "Cunagg' tecamegnung-am aanama taun great-grandma-ma apqangaqekiinga tamakuneng qaillun pillru[cimegnung].",
        "translation": "It turned out that when we arrived, my mother, my great-grandma, asked me what we did with those."
    },
    "51": {
        "startTime": 299.096,
        "endTime": 303.263,
        "transcript": "\"Tua-llu-q' nerellr[uuten]?\" \"Nerqallruunga.\" Quyaklua-llu.",
        "translation": "\"So, did you eat?\" \"I ate.\" And she was thankful that I did."
    },
    "52": {
        "startTime": 303.277,
        "endTime": 311.055,
        "transcript": "Ala caullruat? Mayba aanama calqeńgatai. Calqeńgataanga.",
        "translation": "Oh my, what were they? Maybe it was my mother's doing. She seemed to do something to me."
    },
    "53": {
        "startTime": 311.061,
        "endTime": 313.05,
        "transcript": "Tau͡ga-q' taq'uq?",
        "translation": "Is it done?"
    },
    "54": {
        "startTime": 313.597,
        "endTime": 316.242,
        "transcript": "Ala.",
        "translation": "Oh my goodness."
    },
    "55": {
        "startTime": 317.383,
        "endTime": 321.883,
        "transcript": "Tua-i tamakuneng tau͡ga akaurtellrani pitullruukut.",
        "translation": "That's what we did a long time ago."
    },
    "56": {
        "startTime": 322.42,
        "endTime": 333.617,
        "transcript": "Cali imkunun qetunrayagaqa im' piipiqa, last baby-qa keggluku, anngaan keggluku.",
        "translation": "And my baby son, my last baby was bitten, his older brother bit him."
    },
    "57": {
        "startTime": 333.624,
        "endTime": 338.579,
        "transcript": "Ukuakun tau͡g keggsaaqluku, ukuakun keggsaaqluku malrugneng.",
        "translation": "He bit him here, he bit him here in two spots."
    },
    "58": {
        "startTime": 338.597,
        "endTime": 345.041,
        "transcript": "Maaten alaqaqa makucimeng tegulluni",
        "translation": "I found him and found that he took this kind of thing"
    },
    "59": {
        "startTime": 345.048,
        "endTime": 353.526,
        "transcript": "Taukuk qamavet keggutain enait makucineng kevirturaqai.",
        "translation": "He stuffed the places where the teeth were with this."
    },
    "60": {
        "startTime": 353.537,
        "endTime": 356.704,
        "transcript": "Kevirturluku nemerluku-llu.",
        "translation": "He stuffed and bound them."
    },
    "61": {
        "startTime": 356.718,
        "endTime": 367.24,
        "transcript": "Maaten unuaquani manii ala mamqertelliuq tayima. Puverpalleq-ll' imna red-aulleq tayima.",
        "translation": "The next day, he showed them, and oh my, it healed. And what was red and swollen was gone."
    },
    "62": {
        "startTime": 367.251,
        "endTime": 373.451,
        "transcript": "Tau͡gani clinic-iurtet ellillakelqaat [?].",
        "translation": "At that time, the clinic workers [?] him, [?]."
    },
    "63": {
        "startTime": 373.458,
        "endTime": 375.669,
        "transcript": "Kapurarkauyaaqluni.",
        "translation": "He was supposed to get shots."
    },
    "64": {
        "startTime": 375.683,
        "endTime": 386.038,
        "transcript": "Ayagyunrilami, atakuani wanigg' unuaqu ayagciqluni makucineng kevirturallii nallumteńi.",
        "translation": "Because he didn't want to go, he was supposed to go the evening of the next day, he had stuffed them with these without our knowledge."
    },
    "65": {
        "startTime": 386.054,
        "endTime": 392.32,
        "transcript": "Tayima-ll' mamlliniluteng. Caniluku tayim' makuni piniyuunaku.",
        "translation": "And they healed. And they never said that anything was wrong with this part."
    },
    "66": {
        "startTime": 392.327,
        "endTime": 395.427,
        "transcript": "Makuneng kevirturluku.",
        "translation": "He stuffed it with these."
    },
    "67": {
        "startTime": 395.443,
        "endTime": 400.843,
        "transcript": "Alingtartuq atam ing' piipiqa. Una-llu atam alingtartuq.",
        "translation": "You see, my baby is always scared. These one is always scared too, you see."
    },
    "68": {
        "startTime": 401.05,
        "endTime": 413.416,
        "transcript": "Una im'um aatama ingna... uima ingna uum atii iluracunga'urluqaa.",
        "translation": "My father... his father is my husband's cross cousin."
    },
    "69": {
        "startTime": 413.515,
        "endTime": 418.948,
        "transcript": "Iluraqlutek tau͡ga ak'a, ak'a iluraqumalutek.",
        "translation": "They are cousins, they've been cousins for a long time."
    },
    "70": {
        "startTime": 419.316,
        "endTime": 423.749,
        "transcript": "Tayima'urluq yuunrillruuq qayutun.",
        "translation": "He passed away several years ago."
    },
    "71": {
        "startTime": 423.762,
        "endTime": 430.14,
        "transcript": "Yuunrallran kinguani wii wanigg' keyirma ingkut qetunraanka anglicangnaqluki.",
        "translation": "After he passed away, I've been trying to raise my sons over there by myself."
    },
    "72": {
        "startTime": 430.147,
        "endTime": 437.536,
        "transcript": "Qaniutellraneng, qanrtuutiineng qanruqureluki.",
        "translation": "I always tell them about his precautions."
    },
    "73": {
        "startTime": 437.548,
        "endTime": 443.959,
        "transcript": "Aanama-ll' qanellra unimyuunaku wii, qaniutellra.",
        "translation": "And I never forget what my mother said, her precaution."
    },
    "74": {
        "startTime": 443.973,
        "endTime": 445.317,
        "transcript": "Tau͡ga-qaa?",
        "translation": "Is that all?"
    },
    "75": {
        "startTime": 446.878,
        "endTime": 449.111,
        "transcript": "(Yaa.) Quyana.",
        "translation": "(Yes.) Thank you."
    },
    "76": {
        "startTime": 453.623,
        "endTime": 454.845,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "77": {
        "startTime": 455.699,
        "endTime": 462.466,
        "transcript": "Ii-i, quyana erneqegtaarmeng [?] today.",
        "translation": "Okay, thank you for this wonderful day [?] today."
    },
    "78": {
        "startTime": 462.865,
        "endTime": 473.588,
        "transcript": "Tau͡ga-llu wii angayuqaagka maligtaqungnaqlukek miktellemni yuullrulrianga.",
        "translation": "So, I tried to obey my parents when I was small in my life."
    },
    "79": {
        "startTime": 474.396,
        "endTime": 482.563,
        "transcript": "Aatama-llu qaneryaraa umyugamneng tamayuunani au͡gna qanrullua",
        "translation": "And my father's wisdom never leaves my mind, when he used to tell me"
    },
    "80": {
        "startTime": 483.139,
        "endTime": 490.35,
        "transcript": "Assirpegnii cuukuma, nunanun ayakuma nunakenrilkemnun",
        "translation": "If I do not live well, and I go to other villages that are not my own"
    },
    "81": {
        "startTime": 491.016,
        "endTime": 498.971,
        "transcript": "Atqa niiskunegteggu tau͡gaggun inerciiganii wii callemkun nallungaitniluku.",
        "translation": "If they hear my name, they will know that I am mischievous through what I've done."
    },
    "82": {
        "startTime": 498.978,
        "endTime": 508.445,
        "transcript": "Kaynguyugcetaarlua qanrutellrukiinga. Wanigga-llu umyugaqenriyuunaku tamana wii alerquutekellra.",
        "translation": "He told me to try to make me feel ashamed [to be like that]. And now, I never forget his instruction."
    },
    "83": {
        "startTime": 511.158,
        "endTime": 518.736,
        "transcript": "Aanama cali ilanka naklekureluki pisqelluki qanrut'tullrulua.",
        "translation": "My mother also told me to treat those around me with compassion."
    },
    "84": {
        "startTime": 519.464,
        "endTime": 524.52,
        "transcript": "Elpeci angayuqaci ayagyugarni niiyngaarkaugaci.",
        "translation": "You young people must obey your parents."
    },
    "85": {
        "startTime": 524.522,
        "endTime": 529.3,
        "transcript": "Miktellerpecini-llu qanruyutelci unimeqaqsaunaki.",
        "translation": "And never forget the traditional wisdom passed down to you when you were small."
    },
    "86": {
        "startTime": 529.773,
        "endTime": 537.707,
        "transcript": "Arcaqerluci enem iluani angayuqaci takaqerkaugaci.",
        "translation": "You must especially respect your parents inside the home."
    },
    "87": {
        "startTime": 537.713,
        "endTime": 543.246,
        "transcript": "Qancurlagaksaunaci wall'u-qaa cat pileryagaksaunaki.",
        "translation": "Do not speak harshly or do not do things harshly."
    },
    "88": {
        "startTime": 543.265,
        "endTime": 547.52,
        "transcript": "Angayuqarpeci umyugait pekcetenrilkurrluki.",
        "translation": "Try not to upset your parents."
    },
    "89": {
        "startTime": 547.844,
        "endTime": 557.122,
        "transcript": "Angayuqaaci angayuqaarulriani iluteqaqut nalluvcini qaillun picurlagaluci piaqavci.",
        "translation": "Your parents, those who are parents, are heartbroken without your knowledge when you cause trouble."
    },
    "90": {
        "startTime": 558.021,
        "endTime": 565.354,
        "transcript": "Taumeng tau͡ga-i assirluci uitasqumaluci qanruyutengqertua.",
        "translation": "That is my piece of traditional wisdom, because I want you to be well."
    },
    "91": {
        "startTime": 566.57,
        "endTime": 571.77,
        "transcript": "Tau͡ga-llu ukuk angayuqaagma waten qanrut'tullqaagnenga:",
        "translation": "Then, my parents used to tell me this:"
    },
    "92": {
        "startTime": 573.426,
        "endTime": 584.042,
        "transcript": "Cameng mat'umeng puyumeng-llu wall'u-qaa naryalngunarqelriameng enemni pikuma",
        "translation": "If I do something, smoking, or some other thing that smells bad, in my house"
    },
    "93": {
        "startTime": 584.338,
        "endTime": 592.961,
        "transcript": "Miktellemteńeng ayagluta uqumeng qengaput iluitgun mingutulqai nasqulngunayukluta",
        "translation": "Starting from when we were small, they would apply seal oil inside our noses because we might get headaches [from odors]"
    },
    "94": {
        "startTime": 593.899,
        "endTime": 598.888,
        "transcript": "Tepmun-llu tamatumun assiirutnayukluta.",
        "translation": "And because that odor might adversely affect us."
    },
    "95": {
        "startTime": 599.089,
        "endTime": 606.478,
        "transcript": "Ayuqluku maa-i kaassat. Puyuunrilnge'rmeng kaassat naryalngunarqelriit.",
        "translation": "It's the same with gas. Even though they're not smoke, we get tired of smelling gas."
    },
    "96": {
        "startTime": 606.922,
        "endTime": 616.656,
        "transcript": "Qengaput mingugarkaugaput iluitgun, cali mikelnguut qengait mingugluki",
        "translation": "We must apply [seal oil] inside our noses, and apply it to children's noses."
    },
    "97": {
        "startTime": 617.383,
        "endTime": 629.583,
        "transcript": "Cali-llu cailkamun ayakuvci nangteqkuvci, cuungcautekaituci cailkami uitakuvci arenqiallugeskuvci.",
        "translation": "Also, if you go to the wilderness and suffer, you have no medicine if you have an accident in the wilderness."
    },
    "98": {
        "startTime": 631.784,
        "endTime": 644.184,
        "transcript": "Uquutengqerquvci cakneq quyerluci, qamna assiilkan igyararci [?kapqelqilluni] uqu'urmeng [?]. Aanama pitulqaakut wangkuta.",
        "translation": "If you have seal oil when you have a bad cough, if your throat inside is bad [?with prickling pain], you must [?take] seal oil. My mom used to do that to us."
    },
    "99": {
        "startTime": 644.931,
        "endTime": 650.476,
        "transcript": "Cali-llu quyeryuarassiyaakumta meq'ercilluta.",
        "translation": "Also, if we had a persistant cough, she would have us drink it."
    },
    "100": {
        "startTime": 650.655,
        "endTime": 657.811,
        "transcript": "Aspirin-arkaitellemteńi tau͡gaten miktellemteńi pitulqaakut clinic-angqeyuitellruamta.",
        "translation": "When we didn't have aspirin, she would do that to us when we were small because we had no clinic."
    },
    "101": {
        "startTime": 661.713,
        "endTime": 669.335,
        "transcript": "Cali tau͡ga elluarrluta uitallerkarput nallunaituq.",
        "translation": "It is also clear how we can live well."
    },
    "102": {
        "startTime": 669.63,
        "endTime": 678.73,
        "transcript": "Kitumun ukisqercitaarluta pingramta kia ukisqirciigataakut. Wangkutneng tau͡gaam qaillun elluarrluta cuuyuumaukut.",
        "translation": "Though as for help from anyone, no one can help us. We alone can [have ourselves] live well."
    },
    "103": {
        "startTime": 679.01,
        "endTime": 681.132,
        "transcript": "Quyana cakneq.",
        "translation": "Thank you very much."
    },
    "104": {
        "startTime": 682.303,
        "endTime": 685.414,
        "transcript": "Quyana. Aspiartuq au͡gna.",
        "translation": "Thank you. What you said is very nice."
    },
    "105": {
        "startTime": 688.052,
        "endTime": 693.474,
        "transcript": "Henrietta, John, Carlton, Eddie.",
        "translation": "Henrietty, John, Carlton, Eddie."
    },
    "106": {
        "startTime": 693.48,
        "endTime": 694.135,
        "transcript": "Seven?",
        "translation": "Seven?"
    },
    "107": {
        "startTime": 694.144,
        "endTime": 694.977,
        "transcript": "Seven.",
        "translation": "Seven."
    },
    "108": {
        "startTime": 694.984,
        "endTime": 699.584,
        "transcript": "Wow, fourteen altogether? Tua-i two adopted?",
        "translation": "Wow, fourteen altogether? Then two adopted?"
    },
    "109": {
        "startTime": 710.282,
        "endTime": 713.527,
        "transcript": "Anerteqluteng seven-aat, right?",
        "translation": "Seven are living, right?"
    },
    "110": {
        "startTime": 717.843,
        "endTime": 721.887,
        "transcript": "Qavciugat-mi tutgaraten?",
        "translation": "So, how many grandchildren do you have?"
    },
    "111": {
        "startTime": 722.874,
        "endTime": 726.541,
        "transcript": "I don't know. Amllertut tugaraanka qayutun.",
        "translation": "I don't know. I have many grandchildren."
    },
    "112": {
        "startTime": 728.964,
        "endTime": 730.53,
        "transcript": "Tua-i-q' nutaan-qaa?",
        "translation": "Ready to start now?"
    },
    "113": {
        "startTime": 730.535,
        "endTime": 738.201,
        "transcript": "Man'a taangaq elpecinun assinritqapaireyaaquq atungnaqellra.",
        "translation": "It is not good for you to use this alcohol."
    },
    "114": {
        "startTime": 738.219,
        "endTime": 747.03,
        "transcript": "Tau͡gaam taangaq man'a trouble-aamun tau͡gaam pinaqluni.",
        "translation": "But this alcohol only leads to trouble."
    },
    "115": {
        "startTime": 747.041,
        "endTime": 756.252,
        "transcript": "Cali yuk taangarpakarluni iqlutmun piarkaqenrilkeńi tekilluku ellmineng picurlatuuq.",
        "translation": "Also, when a person abuses alcohol too much, he comes upon something wrong that he's not supposed to do and brings misfortune upon himself."
    },
    "116": {
        "startTime": 756.318,
        "endTime": 760.051,
        "transcript": "Cali man'a meluk aipaa...",
        "translation": "And the other one, smoking..."
    },
    "117": {
        "startTime": 761.373,
        "endTime": 762.94,
        "transcript": "Patuu.",
        "translation": "Close it."
    },
    "118": {
        "startTime": 763.135,
        "endTime": 774.364,
        "transcript": "Aipaa tamana meluk man'a umyugamun taug͡aam ayatulria, man'a-llu tema tapulluku.",
        "translation": "The other one, smoking, goes into this mind along with this body."
    },
    "119": {
        "startTime": 774.376,
        "endTime": 778.754,
        "transcript": "Wii atuyuicaaqaqa qaillun ayuqellra.",
        "translation": "I don't do it, [so I don't know] what it's like."
    },
    "120": {
        "startTime": 778.762,
        "endTime": 788.873,
        "transcript": "Tau͡gaam niitetuama wanigga tamatumeng melugmeng ayuqucianeng, umyugaq tau͡gaam navgutuniluku.",
        "translation": "But I hear about what that smoking is like, that it destroys the mind."
    },
    "121": {
        "startTime": 788.878,
        "endTime": 794.533,
        "transcript": "Cali qavarturangluni tauna melugpakatuli.",
        "translation": "Also, that person who smokes too much starts sleeping a lot."
    },
    "122": {
        "startTime": 794.535,
        "endTime": 799.712,
        "transcript": "Tau͡gaten niitetuunga tamatumeng melugaqata.",
        "translation": "I hear about that when they smoke."
    },
    "123": {
        "startTime": 800.13,
        "endTime": 809.797,
        "transcript": "Iluumuuluni tamana pituyugnarquq, melugpakalria man'a qavarturangluni.",
        "translation": "That is probably true, that one who smoke too much starts sleeping a lot."
    },
    "124": {
        "startTime": 810.124,
        "endTime": 817.424,
        "transcript": "Cali, you know? They forgot what to do.",
        "translation": "Also, you know? They forgot what to do."
    },
    "125": {
        "startTime": 817.436,
        "endTime": 822.158,
        "transcript": "Ellirraarluki-llu cat wanirpaagaq nalluyagutaqluki.",
        "translation": "And after they put things down, they immediately forget them."
    },
    "126": {
        "startTime": 822.177,
        "endTime": 833.07,
        "transcript": "Wii qetunrama iliit tau͡gaten iliit inerqungramteng tamatumeng iliini atuqeryutuata",
        "translation": "One of my sons, though I admonish them, since they sometimes do that"
    },
    "127": {
        "startTime": 833.083,
        "endTime": 843.161,
        "transcript": "Nunutuyaaqanka cakneq wii pirramneng, wangkugtun, wangkugtun... aipaqaqa una.",
        "translation": "I do scold them with what I can, like us, like us... this is my spouse."
    },
    "128": {
        "startTime": 843.176,
        "endTime": 846.621,
        "transcript": "Patuu. Tailuten.",
        "translation": "Close it. Come here."
    },
    "129": {
        "startTime": 850.37,
        "endTime": 852.825,
        "transcript": "That's my husband right here.",
        "translation": "That's my husband right here."
    },
    "130": {
        "startTime": 861.421,
        "endTime": 864.477,
        "transcript": "[?]qiptaarpiiqnang",
        "translation": "Stop [?]."
    },
    "131": {
        "startTime": 865.806,
        "endTime": 867.828,
        "transcript": "Tau͡ga-qaa?",
        "translation": "Ready?"
    },
    "132": {
        "startTime": 868.689,
        "endTime": 870.698,
        "transcript": "Can I quit?",
        "translation": "Can I quit?"
    }
};